import React from "react";
import { useNavigate } from "react-router-dom";
import { Logo } from "../Logo";
import { Button } from "../ui/button";
import { LogOut, Mail, Store, Users, BarChart3 } from "lucide-react";

const ICONS = {
  invitations: Mail,
  merchants: Store,
  leads: Users,
  stats: BarChart3,
};

export function DashboardLayout({
  user,
  sections,
  active,
  onChange,
  onLogout,
  subtitle,
}) {
  const navigate = useNavigate();

  const handleLogout = () => {
    onLogout?.();
    navigate("/login", { replace: true });
  };

  return (
    <div className="min-h-screen bg-[#F5F6F9] flex flex-col">
      <header className="bg-white border-b border-[#E5E7EB]">
        <div className="max-w-7xl mx-auto px-6 sm:px-10 py-4 flex items-center justify-between">
          <Logo size="md" />
          <div className="flex items-center gap-4">
            <div className="text-right hidden sm:block">
              <div className="text-sm font-semibold text-[#191D1E]" data-testid="dashboard-user-name">
                {user.prenom} {user.nom}
              </div>
              <div className="text-xs text-[#939BA0]">{subtitle}</div>
            </div>
            <Button
              variant="outline"
              onClick={handleLogout}
              data-testid="dashboard-logout"
              className="rounded-xl border-[#E5E7EB] hover:bg-[#F5F6F9]"
            >
              <LogOut className="w-4 h-4 mr-2" /> Déconnexion
            </Button>
          </div>
        </div>
      </header>

      <div className="flex-1 max-w-7xl mx-auto w-full px-4 sm:px-8 py-6 lg:py-10 grid grid-cols-1 lg:grid-cols-[220px_1fr] gap-6 lg:gap-10">
        {/* Sidebar */}
        <aside className="lg:sticky lg:top-6 self-start">
          <nav className="bg-white rounded-2xl border border-[#E5E7EB] p-2 flex lg:flex-col gap-1 overflow-x-auto" data-testid="dashboard-sidebar">
            {sections.map((s) => {
              const Icon = ICONS[s.id] || Mail;
              const isActive = s.id === active;
              return (
                <button
                  key={s.id}
                  type="button"
                  onClick={() => onChange(s.id)}
                  data-testid={`sidebar-${s.id}`}
                  className={[
                    "flex items-center gap-3 px-3.5 py-2.5 rounded-xl text-sm font-medium whitespace-nowrap transition-all",
                    isActive
                      ? "bg-[#397DFF] text-white shadow-[0_4px_14px_rgba(57,125,255,0.25)]"
                      : "text-[#687175] hover:bg-[#F5F6F9]",
                  ].join(" ")}
                >
                  <Icon className="w-4 h-4 shrink-0" />
                  <span>{s.label}</span>
                </button>
              );
            })}
          </nav>
        </aside>

        {/* Content */}
        <main className="min-w-0">
          {sections.find((s) => s.id === active)?.content}
        </main>
      </div>
    </div>
  );
}

export default DashboardLayout;
